import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
    FaCalendarAlt, FaClock, FaMapMarkerAlt, FaUserShield,
    FaCamera, FaArrowLeft, FaBuilding, FaChevronLeft,
    FaChevronRight, FaTimes, FaExpandAlt, FaFileAlt, FaIdCard
} from "react-icons/fa";

export default function VisitDetailsPage() {
    const { visitUid } = useParams();
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [loading, setLoading] = useState(true);
    const [visit, setVisit] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);

    useEffect(() => {
        const fetchVisitDetails = async () => {
            setLoading(true);
            try {
                // التحقق مما إذا كان المعامل عبارة عن رقم (ID) أو نص (UID)
                const isNumeric = !isNaN(visitUid) && !isNaN(parseFloat(visitUid));

                // اختيار المسار المناسب بناءً على نوع المعامل
                const endpoint = isNumeric
                    ? `/InspectionVisits/by-id/${visitUid}`
                    : `/InspectionVisits/by-uid/${visitUid}`;

                const response = await backEnd_request.get(endpoint);
                const data = Array.isArray(response.data) ? response.data[0] : response.data;

                setVisit(data);
            } catch (err) {
                console.error("Error fetching visit details:", err);
                // اختياريا: يمكنك إضافة تنبيه للمستخدم هنا قبل العودة
                navigate(-1);
            } finally {
                setLoading(false);
            }
        };

        if (visitUid) {
            fetchVisitDetails();
        }
    }, [visitUid]);

    const nextImage = (e) => {
        e?.stopPropagation();
        if (currentIndex < visit.photos.length - 1) setCurrentIndex(currentIndex + 1);
    };

    const prevImage = (e) => {
        e?.stopPropagation();
        if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    };

    if (loading) return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-white">
            <div className="spinner-grow text-primary" role="status"></div>
        </div>
    );

    if (!visit) return null;

    return (
        <div className="bg-light min-vh-100 pb-5" dir="rtl" style={{ fontFamily: 'Cairo, sans-serif' }}>

            {/* الترويسة (Header) - مطابقة لصفحة الضبط */}
            <div className="header-simple shadow-sm mb-5 pt-3 pb-3 text-white">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <div className="bg-white rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                                <FaIdCard className="text-dark fs-5" />
                            </div>
                            <div>
                                <h4 className="fw-bold mb-0 fs-5">
                                    تفاصيل سجل الزيارة — رقم المرجع: {visit.visitId}
                                </h4>
                                <small className="text-white-50">تاريخ الزيارة: {visit.visitDate?.split("T")[0]}</small>
                            </div>
                        </div>
                        <button className="btn btn-outline-light rounded-pill px-4 d-flex align-items-center gap-2 btn-sm shadow-sm" onClick={() => navigate(-1)}>
                            <span>العودة للقائمة</span>
                            <FaArrowLeft />
                        </button>
                    </div>
                </div>
            </div>

            <div className="container mt-n4">
                <div className="row g-4">

                    {/* 1. بطاقة المعلومات الرئيسية */}
                    <div className="col-12">
                        <div className="main-info-strip shadow-sm">
                            <div className="strip-item main">
                                <label><FaBuilding /> المنشأة</label>
                                <div>{visit.establishment?.name}</div>
                            </div>
                            <div className="strip-divider"></div>
                            <div className="strip-item">
                                <label><FaMapMarkerAlt /> الموقع</label>
                                <div>{visit.governorate} - {visit.district}</div>
                            </div>
                            <div className="strip-divider"></div>
                            <div className="strip-item">
                                <label><FaCalendarAlt /> تاريخ الزيارة</label>
                                <div>{visit.visitDate?.split("T")[0]}</div>
                            </div>
                            <div className="strip-divider"></div>
                            <div className="strip-item">
                                <label><FaFileAlt /> النوع</label>
                                <span className="type-badge">{visit.visitType}</span>
                            </div>
                        </div>
                    </div>

                    {/* 2. التقرير وفريق العمل */}
                    <div className="col-lg-8">
                        <div className="content-card shadow-sm h-100">
                            <div className="card-top-bar">
                                <FaFileAlt className="icon-accent" />
                                <span>تقرير المفتش الميداني</span>
                            </div>
                            <div className="card-body-content">
                                <div className="report-text">
                                    {visit.visitReport || "لا يوجد تقرير نصي متاح لهذه المهمة."}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="content-card shadow-sm h-100">
                            <div className="card-top-bar">
                                <FaUserShield className="icon-accent" />
                                <span>فريق العمل القائم بالمهمة</span>
                            </div>
                            <div className="card-body-content p-0">
                                <ul className="inspectors-list">
                                    {[visit.inspector1Name, visit.inspector2Name, visit.inspector3Name].filter(Boolean).map((name, i) => (
                                        <li key={i}>
                                            <div className="rank">{i + 1}</div>
                                            <div className="name-box">
                                                <span className="name">{name}</span>
                                                <span className="role">{i === 0 ? "رئيس الدورية" : "مفتش"}</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* 3. معرض الصور بالأبعاد الأصلية */}
                    <div className="col-12 mt-2">
                        <div className="gallery-section">
                            <div className="section-title">
                                <FaCamera /> <span>صور الزيارة</span>
                            </div>
                            <div className="row g-4">
                                {visit.photos?.length > 0 ? visit.photos.map((p, index) => (
                                    <div className="col-md-6" key={index}>
                                        <div className="photo-container-premium shadow-sm" onClick={() => setCurrentIndex(index)}>
                                            <img src={p.photoUrl} alt="Field" className="img-fit" />
                                            <div className="photo-overlay-modern">
                                                <div className="zoom-circle"><FaExpandAlt /></div>
                                                <span>انقر للتوسيع</span>
                                            </div>
                                            <div className="photo-index-tag">#{index + 1}</div>
                                        </div>
                                    </div>
                                )) : (
                                    <div className="col-12 empty-state">لا توجد صور توثيقية لهذه الزيارة</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Lightbox */}
            {currentIndex !== null && (
                <div className="modern-lightbox" onClick={() => setCurrentIndex(null)}>
                    <div className="lb-controls" onClick={e => e.stopPropagation()}>
                        <button className="lb-close" onClick={() => setCurrentIndex(null)}><FaTimes /></button>
                        <div className="lb-pager">{currentIndex + 1} / {visit.photos.length}</div>
                    </div>
                    <div className="lb-stage" onClick={e => e.stopPropagation()}>
                        <button className="lb-nav-btn next" onClick={nextImage}><FaChevronLeft /></button>
                        <img src={visit.photos[currentIndex].photoUrl} className="lb-main-img animate-zoom" alt="Detailed View" />
                        <button className="lb-nav-btn prev" onClick={prevImage}><FaChevronRight /></button>
                    </div>
                </div>
            )}

            <style>{`
                .header-simple { background-color: #1a1d20; border-bottom: 2px solid #343a40; }
                .mt-n4 { margin-top: -35px; }

                /* الحفاظ على أبعاد الصور الأصلية 1080 / 1440 */
              
                /* تعديل حاوية الصور لتقليل الارتفاع */
.photo-container-premium { 
    position: relative; 
    /* جعل الارتفاع أقل (نسبة 4:3 بدلاً من 1440:1080) */
    aspect-ratio: 2 / 1.75; 
    background: #1a1d20; /* خلفية داكنة للفراغات */
    border-radius: 16px; 
    overflow: hidden; 
    cursor: pointer;
    border: 4px solid white;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ضمان ظهور الصورة كاملة دون قص */
.img-fit { 
    width: 100%; 
    height: 100%; 
    /* contain يضمن ظهور الصورة كاملة مهما كان طولها */
    object-fit: fit; 
    transition: 0.6s; 
}

/* حركة بسيطة عند التحويم */
.photo-container-premium:hover .img-fit {
    transform: scale(1.05);
}
                .main-info-strip { background: #ffffff; border-radius: 16px; padding: 15px 25px; display: flex; align-items: center; justify-content: space-between; border: 1px solid #e2e8f0; }
                .strip-item label { display: block; font-size: 0.75rem; color: #94a3b8; margin-bottom: 2px; }
                .strip-item div { font-weight: 700; font-size: 1rem; color: #1e293b; }
                .strip-item.main div { color: #0284c7; }
                .strip-divider { width: 1px; height: 40px; background: #f1f5f9; }
                .type-badge { background: #f0f9ff; color: #0369a1; padding: 2px 12px; border-radius: 50px; font-size: 0.75rem; border: 1px solid #bae6fd; font-weight: 600; }

                .content-card { background: white; border-radius: 16px; overflow: hidden; border: 1px solid #e2e8f0; }
                .card-top-bar { padding: 15px 20px; background: #fcfdfe; border-bottom: 1px solid #f1f5f9; display: flex; align-items: center; gap: 10px; font-weight: 700; font-size: 0.9rem; }
                .icon-accent { color: #0284c7; }
                .card-body-content { padding: 20px; }
                .report-text { font-size: 0.95rem; line-height: 1.8; color: #475569; white-space: pre-line; }

                .inspectors-list { list-style: none; padding: 0; margin: 0; }
                .inspectors-list li { display: flex; align-items: center; gap: 15px; padding: 15px 20px; border-bottom: 1px solid #f1f5f9; }
                .inspectors-list .rank { width: 28px; height: 28px; background: #e2e8f0; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 0.75rem; font-weight: 700; }
                .inspectors-list .name-box .name { display: block; font-weight: 600; font-size: 0.9rem; color: #1e293b; }
                .inspectors-list .name-box .role { font-size: 0.7rem; color: #94a3b8; }

                .photo-overlay-modern { position: absolute; inset: 0; background: rgba(15, 23, 42, 0.6); display: flex; flex-direction: column; align-items: center; justify-content: center; color: white; opacity: 0; transition: 0.3s; }
                .photo-container-premium:hover .photo-overlay-modern { opacity: 1; }
                .photo-index-tag { position: absolute; top: 15px; right: 15px; background: white; color: #0f172a; padding: 2px 10px; border-radius: 6px; font-size: 0.75rem; font-weight: 700; }

                .modern-lightbox { position: fixed; inset: 0; background: rgba(0,0,0,0.98); z-index: 2000; display: flex; flex-direction: column; }
                .lb-controls { height: 70px; display: flex; justify-content: space-between; align-items: center; padding: 0 40px; color: white; }
                .lb-stage { flex: 1; display: flex; align-items: center; justify-content: center; position: relative; }
                .lb-main-img { max-width: 90%; max-height: 85vh; object-fit: contain; }
                .lb-nav-btn { background: rgba(255,255,255,0.1); border: none; color: white; font-size: 2.5rem; padding: 20px; border-radius: 50%; position: absolute; }
                .lb-nav-btn.next { left: 40px; }
                .lb-nav-btn.prev { right: 40px; }

                @media (max-width: 768px) {
                    .main-info-strip { flex-direction: column; gap: 15px; align-items: flex-start; }
                    .mt-n4 { margin-top: 0; }
                }
            `}</style>
        </div>
    );
}